import React from 'react';
import styled from 'styled-components';
import { animated, Spring } from 'react-spring';
import ImagePlaceholder from 'js/components/common/ImagePlaceholder';

const Container = animated(styled.div`
  float: left;
  width: 60px;
  border: none;
  text-align: left;
`);

export default ({ style }) => (
  <Container style={style}>
    <Spring native from={{ opacity: 0 }} to={{ opacity: 1 }}>
      {animation => (
        <animated.div style={animation}>
          <ImagePlaceholder noHover />
        </animated.div>
      )}
    </Spring>
  </Container>
);
